import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faEye, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Rating } from 'react-simple-star-rating'

import { useHistory } from 'react-router-dom';

import MyModalDeleteEvaluation from './EvaluationModal/MyModalDeleteEvaluation';

import axios from 'axios';

export default function ClasseNoteCard({idClasse, positionEleve, suivi, classLabel, classLevels, studentCount}) {
    const history = useHistory();
    const [infoNote, setInfoNote] = useState([]);
    const [allNote, setAllNote] = useState([]);
    const [allNoteSave, setAllNoteSave] = useState([]);
    const [allCycle, setAllCycle] = useState([]);
    const [allDiscipline, setAllDiscipline] = useState([]);
    const [cycleSelectedValue, setCycleSelectedValue] = useState(null);
    const [disciplineSelectedValue, setDisciplineSelectedValue] = useState(null);

    const [infoNoteModal, setInfoNoteModal] = useState([]);
    const [rowModal, setRowModal] = useState([]);

    const [modalIsOpen, setIsOpen] = React.useState(false);

    function showNote(idClasse, idSeance, detailSeance, infoNote) {
        history.push({
            pathname: '/note',
            state: {
                id_classe: idClasse,
                id_seance: idSeance,
                detailSeance,
                infoNote,
                positionEleve,
                classLabel,
                classLevels,
                studentCount,
            },
        });
    }

    function openFromParent(modalNumber, infoNoteModal, rowModal) {
        switch(modalNumber) {
          case 1:
            setIsOpen(true);
            setInfoNoteModal(infoNoteModal)
            setRowModal(rowModal)
            break;
          default:
            break;
        }
    }

    function handleCloseModal(event, data) {
        switch(data) {
          case 1:
            setIsOpen(false);
            break;
          default:
            break;
        }
    }

    function handleEvaluationDeleted(idSeance) {
        const keepOtherSeances = (row) => String(row.noteInfo && row.noteInfo.id_seance) !== String(idSeance);
        const remainingNotes = allNoteSave.filter(keepOtherSeances);
        setAllNoteSave(remainingNotes);
        setAllNote(remainingNotes);
        setInfoNote(remainingNotes.map((row) => row.noteInfo));
        parseData(remainingNotes.map((row) => row.noteInfo));
    }

    function parseData(data) {
        var allCycleVar = []
        var allDisciplineVar = []
        data.map((row, index) => {
            if(!allCycleVar.includes(row.id_cycle)) {
                allCycleVar.push(row.id_cycle)
            }
            if(!allDisciplineVar.includes(row.nom_sequence)) {
                allDisciplineVar.push(row.nom_sequence)
            }
            return true
        })
        setAllCycle(allCycleVar.sort())
        setAllDiscipline(allDisciplineVar.sort())
    }

    function selectFilter(value, pos) {
        const nextCycle = pos === 1 ? (value === '0' ? null : value) : cycleSelectedValue;
        const nextDiscipline = pos === 2 ? (value === '0' ? null : value) : disciplineSelectedValue;

        setCycleSelectedValue(nextCycle);
        setDisciplineSelectedValue(nextDiscipline);

        const filteredNotes = allNoteSave.filter((row) => {
            const noteInfo = row.noteInfo || {};
            const cycleMatches = nextCycle === null || String(noteInfo.id_cycle) === String(nextCycle);
            const disciplineMatches = nextDiscipline === null || noteInfo.nom_sequence === nextDiscipline;
            return cycleMatches && disciplineMatches;
        });

        setAllNote(filteredNotes)
        setInfoNote(filteredNotes.map((row) => row.noteInfo))
    }

    React.useEffect(() => {
        if (!idClasse) return;

        setInfoNote([])
        setAllNote([])
        setAllNoteSave([])
        setAllCycle([])
        setAllDiscipline([])
        setCycleSelectedValue(null)
        setDisciplineSelectedValue(null)

        axios.get('https://eps.acces-editions.com/api/getNoteSceance?id_classe='+idClasse)
        .then(async (res) => {
            if(res.data[0] !== undefined)
            {
                parseData(res.data)
                const combinedNotes = await Promise.all(res.data.map(async (noteInfo) => {
                    try {
                        const result = await axios.get('https://eps.acces-editions.com/api/getDetailSeance?id='+noteInfo.id_seance)
                        const detail = result.data && result.data.detailSeance && result.data.detailSeance[0]
                        return detail ? { ...detail, noteInfo } : null
                    } catch (error) {
                        return null
                    }
                }))
                const availableNotes = combinedNotes.filter(Boolean)
                setAllNote(availableNotes)
                setAllNoteSave(availableNotes)
                setInfoNote(availableNotes.map((row) => row.noteInfo))
            } else {
                setAllNote([])
            }
        })
        .catch(() => {
            setInfoNote([])
            setAllNote([])
            setAllNoteSave([])
        })
    }, [idClasse]);

    return (
        <div>
            <MyModalDeleteEvaluation
                IsModalOpened={modalIsOpen}
                onCloseModal={handleCloseModal}
                infoNoteModal={infoNoteModal}
                rowModal={rowModal}
                idClasse={idClasse}
                onDeleted={handleEvaluationDeleted}
                key={modalIsOpen ? 'delete-evaluation-open' : 'delete-evaluation-closed'}
            />
            <section className="ae-workspace-card">
                <header className="ae-workspace-card-header">
                    <span className="ae-workspace-card-icon"><FontAwesomeIcon icon={faChartLine} /></span>
                    <div>
                        <h2>Tableau de bord de la classe</h2>
                        <p>Retrouvez les évaluations réalisées et accédez au détail des résultats.</p>
                    </div>
                </header>

                <div className="ae-workspace-card-body">
                    {(allCycle.length > 0 || allDiscipline.length > 0) && (
                        <div className="ae-workspace-filter-grid ae-workspace-filter-grid--compact">
                            <div className={`ae-workspace-field${allCycle.length === 0 ? ' ae-workspace-field--disabled' : ''}`}>
                                <label htmlFor="dashboard-cycle">Cycle</label>
                                <select id="dashboard-cycle" disabled={allCycle.length === 0} onChange={(e) => selectFilter(e.target.value, 1)}>
                                    <option value="0">Tous les cycles</option>
                                    {allCycle.map((row) => <option key={row} value={row}>Cycle {row}</option>)}
                                </select>
                            </div>
                            <div className={`ae-workspace-field${allDiscipline.length === 0 ? ' ae-workspace-field--disabled' : ''}`}>
                                <label htmlFor="dashboard-sequence">Séquence</label>
                                <select id="dashboard-sequence" disabled={allDiscipline.length === 0} onChange={(e) => selectFilter(e.target.value, 2)}>
                                    <option value="0">Toutes les séquences</option>
                                    {allDiscipline.map((row) => <option key={row} value={row}>{row}</option>)}
                                </select>
                            </div>
                        </div>
                    )}

                    {allNote.length > 0 ? (
                        <div className="ae-workspace-table-wrap">
                            <table className="ae-workspace-table ae-workspace-table--evaluations">
                                <thead>
                                    <tr>
                                        <th>Cycle</th>
                                        <th>Discipline</th>
                                        <th>Activité</th>
                                        <th>Objectif</th>
                                        <th>Moyenne</th>
                                        <th>Élèves évalués</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...allNote].sort((a, b) => a.id > b.id ? 1 : -1).map((row, index) => {
                                        const noteInfo = row.noteInfo || infoNote[index] || {};
                                        return (
                                            <tr key={row.id+"_"+index+"_child"} id={row.id+"_"+index+"_child"}>
                                                <td data-label="Cycle">Cycle {noteInfo.id_cycle || '—'}</td>
                                                <td data-label="Discipline">{noteInfo.nom_sequence || '—'}</td>
                                                <td data-label="Activité"><strong>{row.titre_activite}</strong></td>
                                                <td data-label="Objectif">{row.objectif}</td>
                                                <td data-label="Moyenne">
                                                    <span className="ae-workspace-rating">
                                                        <Rating
                                                            initialValue={(noteInfo.totalNote || 0) / (noteInfo.nbNote || 1)}
                                                            size={18}
                                                            transition
                                                            fillColor='orange'
                                                            emptyColor='#d5dbe7'
                                                            iconsCount={4}
                                                            readonly
                                                        />
                                                    </span>
                                                </td>
                                                <td data-label="Élèves évalués">{noteInfo.nbNote || 0}</td>
                                                <td data-label="Actions">
                                                    <div className="ae-workspace-row-actions">
                                                        <button type="button" className="ae-workspace-secondary-button" onClick={(e) => {e.preventDefault(); showNote(idClasse, row.id, row, noteInfo)}}>
                                                            <FontAwesomeIcon icon={faEye} />
                                                            <span>Voir</span>
                                                        </button>
                                                        <button type="button" className="ae-workspace-danger-button" onClick={() => openFromParent(1, noteInfo, row)}>
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                            <span>Supprimer</span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="ae-workspace-empty">Vous n'avez aucune évaluation pour cette sélection.</p>
                    )}
                </div>
            </section>
        </div>
    );
}
